export default __webpack_public_path__ + "static/media/popsicle-fi.5bbbaef2.jpeg";